const OverChargeClaimsTypes = {
  SET_OVERCHARGE_FILTERS: 'OVERCHARGE_CLAIMS_TYPE.SET_OVERCHARGE_FILTERS',
  SET_OVERCHARGE_EDIT_DRAWER: 'OVERCHARGE_CLAIMS_TYPE.SET_OVERCHARGE_EDIT_DRAWER',
  SET_OVERCHARGE_CLAIM_EDIT_ACTIVE_KEY: 'OVERCHARGE_CLAIMS_TYPE.SET_OVERCHARGE_CLAIM_EDIT_ACTIVE_KEY',

  GET_OVERCHARGE_LIST_PROGRESS: 'OVERCHARGE_CLAIMS_TYPE.GET_OVERCHARGE_LIST_PROGRESS',
  GET_OVERCHARGE_LIST_SUCCESS: 'OVERCHARGE_CLAIMS_TYPE.GET_OVERCHARGE_LIST_SUCCESS',
  GET_OVERCHARGE_LIST_ERROR: 'OVERCHARGE_CLAIMS_TYPE.GET_OVERCHARGE_LIST_ERROR',
  SET_OVERCHARGE_LIST: 'OVERCHARGE_CLAIMS_TYPE.SET_OVERCHARGE_LIST',

  SET_SELECTED_OVERCHARGE_CLAIMS: 'OVERCHARGE_CLAIMS_TYPE.SET_SELECTED_OVERCHARGE_CLAIMS',

  DELETE_OVERCHARGE_CLAIM_PROGRESS: 'OVERCHARGE_CLAIMS_TYPE.DELETE_OVERCHARGE_CLAIM_PROGRESS',

  GET_OVERCHARGE_CLAIM_DETAILS_PROGRESS: 'OVERCHARGE_CLAIMS_TYPE.GET_OVERCHARGE_CLAIM_DETAILS_PROGRESS',
  GET_OVERCHARGE_CLAIM_DETAILS_SUCCESS: 'OVERCHARGE_CLAIMS_TYPE.GET_OVERCHARGE_CLAIM_DETAILS_SUCCESS',
  GET_OVERCHARGE_CLAIM_DETAILS_ERROR: 'OVERCHARGE_CLAIMS_TYPE.GET_OVERCHARGE_CLAIM_DETAILS_ERROR',

  UPDATE_OVERCHARGE_CLAIM_PROGRESS: 'OVERCHARGE_CLAIMS_TYPE.UPDATE_OVERCHARGE_CLAIM_PROGRESS',

  SEND_CLAIM_PDF_TO_CARRIER_PROGRESS: 'OVERCHARGE_CLAIMS_TYPE.SEND_CLAIM_PDF_TO_CARRIER_PROGRESS',
  SEND_CLAIM_PDF_TO_CARRIER_SUCCESS: 'OVERCHARGE_CLAIMS_TYPE.SEND_CLAIM_PDF_TO_CARRIER_SUCCESS',
  SEND_CLAIM_PDF_TO_CARRIER_ERROR: 'OVERCHARGE_CLAIMS_TYPE.SEND_CLAIM_PDF_TO_CARRIER_ERROR',

  GET_CLAIM_EMAIL_HISTORY_PROGRESS: 'OVERCHARGE_CLAIMS_TYPE.GET_CLAIM_EMAIL_HISTORY_PROGRESS',
  GET_CLAIM_EMAIL_HISTORY_SUCCESS: 'OVERCHARGE_CLAIMS_TYPE.GET_CLAIM_EMAIL_HISTORY_SUCCESS',
  GET_CLAIM_EMAIL_HISTORY_ERROR: 'OVERCHARGE_CLAIMS_TYPE.GET_CLAIM_EMAIL_HISTORY_ERROR',

  GET_ITEMS_FROM_EXCEL_PROGRESS: 'OVERCHARGE_CLAIMS_TYPE.GET_ITEMS_FROM_EXCEL_PROGRESS',
  GET_ITEMS_FROM_EXCEL_SUCCESS: 'OVERCHARGE_CLAIMS_TYPE.GET_ITEMS_FROM_EXCEL_SUCCESS',
  GET_ITEMS_FROM_EXCEL_ERROR: 'OVERCHARGE_CLAIMS_TYPE.GET_ITEMS_FROM_EXCEL_ERROR',

  CREATE_OVERCHARGE_CLAIM_PROGRESS: 'OVERCHARGE_CLAIMS_TYPE.CREATE_OVERCHARGE_CLAIM_PROGRESS',
  CREATE_OVERCHARGE_CLAIM_SUCCESS: 'OVERCHARGE_CLAIMS_TYPE.CREATE_OVERCHARGE_CLAIM_SUCCESS',
  CREATE_OVERCHARGE_CLAIM_ERROR: 'OVERCHARGE_CLAIMS_TYPE.CREATE_OVERCHARGE_CLAIM_ERROR',
  CREATE_OVERCHARGE_CLAIM_RESET: 'OVERCHARGE_CLAIMS_TYPE.CREATE_OVERCHARGE_CLAIM_RESET',

  SET_CLAIM_SEARCH_VIEW_TYPE: 'OVERCHARGE_CLAIMS_TYPE.SET_CLAIM_SEARCH_VIEW_TYPE',
  SET_CLAIM_SEARCH_VIEW_TYPE_INITIAL: 'OVERCHARGE_CLAIMS_TYPE.SET_CLAIM_SEARCH_VIEW_TYPE_INITIAL',

  GET_TABLE_VIEW_COLUMNS_PROGRESS: 'OVERCHARGE_CLAIMS_TYPE.GET_TABLE_VIEW_COLUMNS_PROGRESS',
  GET_TABLE_VIEW_COLUMNS_SUCCESS: 'OVERCHARGE_CLAIMS_TYPE.GET_TABLE_VIEW_COLUMNS_SUCCESS',
  GET_TABLE_VIEW_COLUMNS_ERROR: 'OVERCHARGE_CLAIMS_TYPE.GET_TABLE_VIEW_COLUMNS_ERROR',

  GET_SORTING_FIELDS_PROGRESS: 'OVERCHARGE_CLAIMS_TYPE.GET_SORTING_FIELDS_PROGRESS',
  GET_SORTING_FIELDS_SUCCESS: 'OVERCHARGE_CLAIMS_TYPE.GET_SORTING_FIELDS_SUCCESS',
  GET_SORTING_FIELDS_ERROR: 'OVERCHARGE_CLAIMS_TYPE.GET_SORTING_FIELDS_ERROR',

  SAVE_TABLE_VIEW_COLUMNS_PROGRESS: 'OVERCHARGE_CLAIMS_TYPE.SAVE_TABLE_VIEW_COLUMNS_PROGRESS',
  SAVE_TABLE_VIEW_COLUMNS_SUCCESS: 'OVERCHARGE_CLAIMS_TYPE.SAVE_TABLE_VIEW_COLUMNS_SUCCESS',
  SAVE_TABLE_VIEW_COLUMNS_ERROR: 'OVERCHARGE_CLAIMS_TYPE.SAVE_TABLE_VIEW_COLUMNS_ERROR',

  GET_CLAIM_NOTES_PROGRESS: 'OVERCHARGE_CLAIMS_TYPE.GET_CLAIM_NOTES_PROGRESS',
  GET_CLAIM_NOTES_SUCCESS: 'OVERCHARGE_CLAIMS_TYPE.GET_CLAIM_NOTES_SUCCESS',
  GET_CLAIM_NOTES_ERROR: 'OVERCHARGE_CLAIMS_TYPE.GET_CLAIM_NOTES_ERROR',

  GET_CLAIM_SETTLEMENTS_PROGRESS: 'OVERCHARGE_CLAIMS_TYPE.GET_CLAIM_SETTLEMENTS_PROGRESS',
  GET_CLAIM_SETTLEMENTS_SUCCESS: 'OVERCHARGE_CLAIMS_TYPE.GET_CLAIM_SETTLEMENTS_SUCCESS',
  GET_CLAIM_SETTLEMENTS_ERROR: 'OVERCHARGE_CLAIMS_TYPE.GET_CLAIM_SETTLEMENTS_ERROR',

  GET_CLAIM_ITEMS_PROGRESS: 'OVERCHARGE_CLAIMS_TYPE.GET_CLAIM_ITEMS_PROGRESS',
  GET_CLAIM_ITEMS_SUCCESS: 'OVERCHARGE_CLAIMS_TYPE.GET_CLAIM_ITEMS_SUCCESS',
  GET_CLAIM_ITEMS_ERROR: 'OVERCHARGE_CLAIMS_TYPE.GET_CLAIM_ITEMS_ERROR',

  APPLY_CLAIM_RECOVERY_PERCENT_PROGRESS: 'OVERCHARGE_CLAIMS_TYPE.APPLY_CLAIM_RECOVERY_PERCENT_PROGRESS',
  APPLY_CLAIM_RECOVERY_PERCENT_SUCCESS: 'OVERCHARGE_CLAIMS_TYPE.APPLY_CLAIM_RECOVERY_PERCENT_SUCCESS',
  APPLY_CLAIM_RECOVERY_PERCENT_ERROR: 'OVERCHARGE_CLAIMS_TYPE.APPLY_CLAIM_RECOVERY_PERCENT_ERROR',
};

export default OverChargeClaimsTypes;
